import { render, staticRenderFns } from "./designatedCustomer.vue?vue&type=template&id=a641f02e&scoped=true&"
import script from "./designatedCustomer.vue?vue&type=script&lang=js&"
export * from "./designatedCustomer.vue?vue&type=script&lang=js&"
import style0 from "./designatedCustomer.vue?vue&type=style&index=0&id=a641f02e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a641f02e",
  null
  
)

export default component.exports